export default __webpack_public_path__ + "static/media/edit_icon.c406e0ab.svg";